import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


export const getList = (params) => {
  return axios.post(root + '/voucher/accountvoucherdetail/list', qs.stringify(params))
}
//统计
export const getListTJ = (params) => {
  return axios.post(root + '/voucher/accountvoucherdetail/listtj', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/voucher/accountvoucherdetail/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/voucher/accountvoucherdetail/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/voucher/accountvoucherdetail/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/voucher/accountvoucherdetail/save', qs.stringify(params))
  }
}




// WEBPACK FOOTER //
// ./src/api/voucher/accountvoucherdetail.js